import { ArrayInput, FormDataConsumer, SimpleFormIterator } from "react-admin";
import Inputs from "./Inputs";

export default function BonusSaleItemForm() {
  return (
    <ArrayInput
      source="bonus_sale_items"
      defaultValue={[
        {
          sale_order_item_id: "",
          bonus_product_id: "",
          sent_quantity: "",
          name: "", // disabled
        },
      ]}
    >
      <SimpleFormIterator
        disableReordering
        getItemLabel={(index) => `#${index + 1}`}
        fullWidth={true}
        sx={{
          "& .RaSimpleFormIterator-line": {
            border: "none",
          },
        }}
      >
        <FormDataConsumer>{Inputs}</FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
}
